import { render, staticRenderFns } from "./sign-reports.vue?vue&type=template&id=50d336ca"
import script from "./sign-reports.vue?vue&type=script&lang=js"
export * from "./sign-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports